import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigurationService, HttpBaseService, LocalizationService, NotifyService } from '@app/core';
import { ApiControllerEnum } from '@app/shared/common/enums';
import { Observable } from 'rxjs';
import { ApplicantRecordItem } from '../models/applicant-record-item';

@Injectable({
  providedIn: 'root'
})
export class ApplicantRecordService extends HttpBaseService {

    constructor(private http: HttpClient
        , private notifyServ: NotifyService
        , private localizationService: LocalizationService
        , private configService: ConfigurationService) {
        super(http, ApiControllerEnum.S3File, notifyServ, localizationService, configService);
      }

      ListImagesInApplicantFolderAsync(filter: any): Observable<ApplicantRecordItem> {
        return this.post("ListImagesInApplicantFolderAsync", filter, true);
      }
    }
